import { render, staticRenderFns } from "./simple-dropdown.vue?vue&type=template&id=3409e529&"
import script from "./simple-dropdown.vue?vue&type=script&lang=ts&"
export * from "./simple-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\references\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3409e529')) {
      api.createRecord('3409e529', component.options)
    } else {
      api.reload('3409e529', component.options)
    }
    module.hot.accept("./simple-dropdown.vue?vue&type=template&id=3409e529&", function () {
      api.rerender('3409e529', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/simple-dropdown/simple-dropdown.vue"
export default component.exports